import { useSuspenseQuery } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';

import { AddButtonLink, Browse, usePagination } from '@/core/components';

import { FilterBox, SearchFilter, useSearch, useSortDirection } from '@feature/utils';

import { ConferenceCard } from './components/Card/ConferenceCard';
import { getConferencePagedOptions } from './model/ConferenceQuery';

export function ConferenceBrowse() {
  const { t } = useTranslation();
  const { sortDirection, toggleSortDirection } = useSortDirection('DESC');
  const { search, searchProps } = useSearch();
  const { pagination, useTotalElements, ...paginationProps } = usePagination({ search });
  const { data } = useSuspenseQuery(
    getConferencePagedOptions({
      ...pagination,
      sortDirection,
      search,
    }),
  );
  useTotalElements(data);

  return (
    <Browse
      actions={<AddButtonLink />}
      title={t('conferences.title')}
      subtitle={t('conferences.subtitle')}
      pagination={paginationProps}
      filters={
        <FilterBox>
          <SearchFilter
            label={t('label.search')}
            description={t('conferences.searchBy')}
            {...searchProps}
          />
        </FilterBox>
      }
      sortDirection={sortDirection}
      sortedBy={t('conferences.sortedByPublishDate')}
      toggleSortDirection={toggleSortDirection}
      data={data.list}
      renderItem={conference => (
        <ConferenceCard
          key={conference.id}
          conference={conference}
          to={`${conference.id}`}
        />
      )}
    />
  );
}
